import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

export default function PoliticaCookies() {
  return (
    <>
      <Helmet>
        <title>Política de Cookies | Inerva Psicología</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <Header />

      <main className="min-h-screen bg-cream pt-28 pb-20">
        <div className="container-narrow">
          <div className="max-w-3xl mx-auto bg-white rounded-2xl p-8 md:p-12 shadow-sm">
            <h1 className="text-3xl md:text-4xl mb-2 text-center">Política de Cookies</h1>
            <p className="text-sm text-[var(--color-inerva-text-light)] text-center mb-10">
              Última actualización: 8 de agosto de 2025
            </p>

            <div className="prose prose-sm max-w-none prose-headings:font-serif prose-headings:text-[var(--color-inerva-forest)] prose-p:text-[var(--color-inerva-text)] prose-li:text-[var(--color-inerva-text)]">
              <h2>Qué son las cookies</h2>
              <p>
                Una cookie es un fichero que se descarga en su ordenador, teléfono móvil, tablet, etc,
                al acceder a determinados sitios web. Las cookies permiten a un sitio web almacenar y
                recuperar información sobre los hábitos de navegación de un usuario o de su equipo y,
                dependiendo de la información que contengan y de la forma en que utilice su equipo,
                pueden utilizarse para reconocer al usuario.
              </p>
              <ul>
                <li>Desde un punto de vista técnico, permiten que el sitio web funcione de forma más ágil y adaptado a las preferencias de los usuarios.</li>
                <li>Establecen niveles de protección y seguridad que impiden o dificultan ciberataques.</li>
                <li>Permiten conocer datos estadísticos recopilados en las cookies para mejorar la calidad del servicio.</li>
                <li>Sirven para optimizar la publicidad mostrada a los usuarios.</li>
              </ul>

              <h2>Tipos de cookies que existen</h2>
              <p>Según quien gestione el dominio desde donde se envían las cookies, se distinguen:</p>
              <ul>
                <li><strong>Cookies propias:</strong> Enviadas desde un dominio gestionado por el editor del sitio web.</li>
                <li><strong>Cookies de terceros:</strong> Enviadas desde un dominio no gestionado por el editor, sino por otra entidad.</li>
              </ul>

              <p>También se clasifican según el tiempo que permanecen almacenadas:</p>
              <ul>
                <li><strong>Cookies de sesión:</strong> Se eliminan al cerrar el navegador.</li>
                <li><strong>Cookies persistentes:</strong> Permanecen durante un periodo definido (de minutos a años).</li>
              </ul>

              <p>Y según su finalidad:</p>
              <ul>
                <li><strong>Cookies de sesión PHP:</strong> Necesarias para el funcionamiento del sitio y gestión de idiomas.</li>
                <li><strong>Cookies de personalización:</strong> Adaptan la interfaz a idioma, región, navegador, etc.</li>
                <li><strong>Cookies de análisis:</strong> Permiten analizar el comportamiento de los usuarios y mejorar el servicio.</li>
                <li><strong>Cookies publicitarias:</strong> Gestionan los espacios publicitarios.</li>
                <li><strong>Cookies de publicidad comportamental:</strong> Muestran anuncios personalizados según los hábitos del usuario.</li>
                <li><strong>Cookies de redes sociales externas:</strong> Permiten la interacción con contenidos de redes como Facebook, YouTube o LinkedIn.</li>
              </ul>

              <h2>Tipos de cookies utilizadas en este sitio web</h2>

              <h3>Cookies de análisis (Google Analytics 4)</h3>
              <ul>
                <li><strong>_ga:</strong> Distingue usuarios únicos. <em>Duración: 2 años.</em></li>
                <li><strong>_ga_KEN7HTW639:</strong> Cookie específica para recopilar datos estadísticos. <em>Duración: 2 años.</em></li>
                <li><strong>_gid:</strong> Distingue usuarios únicos en periodos cortos. <em>Duración: 24 horas.</em></li>
              </ul>

              <h3>Cookies técnicas</h3>
              <ul>
                <li><strong>Cookies de sesión PHP:</strong> Necesarias para el funcionamiento del sitio. <em>Duración: sesión del navegador.</em></li>
              </ul>

              <h2>Gestión de consentimiento</h2>
              <p>
                Todas las cookies de análisis se cargan únicamente tras la interacción del usuario con el sitio web
                (scroll, clic, etc.) o después de 5 segundos, cumpliendo con la normativa de privacidad europea.
              </p>

              <h2>Revocación del consentimiento para instalar cookies</h2>
              <p>
                El usuario puede revocar en cualquier momento el consentimiento previamente otorgado y gestionar
                las cookies desde la configuración de su navegador:
              </p>

              <h3>Chrome</h3>
              <p>
                Más información: <a href="http://support.google.com/chrome/answer/95647?hl=es" target="_blank" rel="noopener noreferrer">support.google.com/chrome/answer/95647</a>
              </p>

              <h3>Firefox</h3>
              <p>
                Más información: <a href="https://www.mozilla.org/es-ES/privacy/websites/#cookies" target="_blank" rel="noopener noreferrer">mozilla.org/es-ES/privacy/websites/#cookies</a>
              </p>

              <h3>Safari</h3>
              <p>
                Más información: <a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">support.apple.com/es-es/guide/safari</a>
              </p>

              <h3>Opera</h3>
              <p>
                Más información: <a href="https://help.opera.com/en/latest/security-and-privacy/#clearBrowsingData" target="_blank" rel="noopener noreferrer">help.opera.com/en/latest/security-and-privacy</a>
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}
